package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_tag_data_di_TagModule : Module get() = module {
	single() { _ -> com.essntl.features.tag.data.repository.TagRepositoryImpl(supabase=get()) } bind(com.essntl.features.tag.domain.repository.TagRepository::class)
	single() { _ -> com.essntl.features.tag.data.supabase.TagSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.tag.data.supabase.TagSupabaseDataSource::class)
}
public val com.essntl.features.tag.data.di.TagModule.module : org.koin.core.module.Module get() = com_essntl_features_tag_data_di_TagModule
